import React from "react";
import Service from "../../../services/bodyParams";
import { BodyParamsItem } from "../../../types/types";

type Props = {
  item: BodyParamsItem;
  onDelete: (id: number) => void;
  closeModal: () => void;
  t: any;
};

const OptionsDelete: React.FC<Props> = ({ item, onDelete, closeModal, t }) => {
  const deleteItem = () => {
    Service.deleteBodyParam(item.id)
      .then(() => {
        onDelete(item.id);
        closeModal();
      })
      .catch((error) => console.error("Delete error", error));
  };

  return (
    <div>
      <button onClick={deleteItem} className="buttonDelete">
        {t("buttons.delete")}
      </button>
    </div>
  );
};

export default OptionsDelete;
